export const notificationText = {
  en: { title: 'Notifications', none: 'No notifications yet', markAll: 'Mark all read',
        clear: 'Clear all', clearConfirm: 'Clear all notifications?',
        reply: 'replied in a thread you are in', mention: 'mentioned you',
        reaction: 'reacted to your comment' },
  es: { title: 'Notificaciones', none: 'Sin notificaciones', markAll: 'Marcar todo',
        clear: 'Borrar todo', clearConfirm: '¿Borrar todas las notificaciones?',
        reply: 'respondió en un hilo tuyo', mention: 'te mencionó',
        reaction: 'reaccionó a tu comentario' },
  zh: { title: '通知', none: '目前沒有通知', markAll: '全部標為已讀',
        clear: '清除全部', clearConfirm: '確定清除所有通知？',
        reply: '在你參與的討論中回覆了', mention: '提到了你',
        reaction: '對你的留言做出回應' },
  sc: { title: '通知', none: '目前没有通知', markAll: '全部标为已读',
        clear: '清除全部', clearConfirm: '确定清除所有通知？',
        reply: '在你参与的讨论中回复了', mention: '提到了你',
        reaction: '对你的留言做出回应' },
};
